/* eslint-env browser */
import { useState, useEffect } from 'react';
import { GOOGLE_MAPS_API_KEY } from '../actions/const';

const UseGoogleMapsLoader = (language = 'da') => {
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  useEffect(() => {
    // Check if the script is already loaded
    if (window.google && window.google.maps) {
      setIsGoogleMapsLoaded(true);
      return undefined;
    }

    // If the script is already loading, poll until it's available
    if (window.googleMapsScriptIsLoading) {
      const checkIfLoaded = setInterval(() => {
        if (window.google && window.google.maps) {
          setIsGoogleMapsLoaded(true);
          clearInterval(checkIfLoaded);
        }
      }, 100);

      return () => clearInterval(checkIfLoaded); // Return cleanup function
    }

    // Mark the script as loading
    window.googleMapsScriptIsLoading = true;

    // Create the script element and load Google Maps
    const script = document.createElement('script');
    const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&language=${language}&loading=async&callback=googleMapsCallback`;
    script.src = scriptUrl;
    script.async = true;

    // Handle successful script loading
    window.googleMapsCallback = () => {
      setIsGoogleMapsLoaded(true);
      window.googleMapsScriptIsLoading = false;
    };

    // Handle script load error
    script.onerror = () => {
      window.googleMapsScriptIsLoading = false;
    };

    // Append the script to the document's head
    document.head.appendChild(script);

    // Return cleanup function
    return () => {
      window.googleMapsCallback = null; // Cleanup the callback
    };
  }, [language]);

  return isGoogleMapsLoaded;
};

export default UseGoogleMapsLoader;
